import { Constant } from "../../Constant";

const clo = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.GET_CLO_INFO.DONE:
            return { ...payload };
        default:
            return state;
    }
};

export default clo;
